var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card time"},[_c('div',{staticClass:"header"},[_c('div',{staticClass:"title"},[_vm._v("其他营收")])]),_c('div',{staticClass:"chart",attrs:{"id":"otherSalesCharts"}})])
}]

export { render, staticRenderFns }